import * as ImagePicker from 'expo-image-picker';
import { Platform } from 'react-native';

export async function hasCameraPermission(): Promise<boolean> {
  if (Platform.OS === 'web') {
    return false;
  }
  const { status } = await ImagePicker.requestCameraPermissionsAsync();
  return status === ImagePicker.PermissionStatus.GRANTED;
}
